module.exports = __webpack_public_path__ + "img/protect.f02377e7.svg";